import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CancellationListComponent } from '../cancellation/cancellation-list.component';
import { CancellationComponent } from '../cancellation/cancellation.component';
import { HomeComponent } from '../home/home.component';
import { AnalysisComponent } from '../analysis/analysis.component';
import { SubscriptionComponent } from '../subscription/subscription.component';
import { OrderComponent } from '../order/order.component';
import { FastOrderComponent } from '../order/fast-process/fast-order.component';
import { CustomerInfosComponent } from '../customer-infos/customer-infos.component';
import { CustomerInfosOrderComponent } from '../customer-infos/customer-infos-order.component';
import { LoginComponent } from '../login/login.component';
import { BypassAuthComponent } from '../bypassAuth/bypass-auth.component';
import { AccountComponent } from '../account/account.component';
import { SignupComponent } from '../signup/signup.component';

import { AnalysisResolver } from '../resolvers/analysis.resolver';
import { CancellationResolver } from '../resolvers/cancellation.resolver';
import { CancellationListResolver } from '../resolvers/cancellation-list.resolver';
import { OrderResolver } from '../resolvers/order.resolver';
import { FastOrderResolver } from '../resolvers/fast-order.resolver';
import { EditOrderResolver } from '../resolvers/edit-order.resolver';
import { SiretLabsResolver } from '../resolvers/siret-lab.resolver';
import { RequestStatusResolver } from '../resolvers/request-status.resolver';
import { CustomerInfosResolver } from '../resolvers/customer-infos.resolver';
import { CustomerInfosOrderResolver } from '../resolvers/customer-infos-order.resolver';
import { SubscriptionResolver } from '../resolvers/subscription.resolver';

import { AuthGuard } from '../security/auth.guard';
import { IsDairyGuard } from '../security/is-dairy.guard';
import { IsNotDairyGuard } from '../security/is-not-dairy.guard';
import { AdditionalDocsComponent } from '../additional-docs/additional-docs.component';
import { AdditionalDocResolver } from '../resolvers/additional-doc.resolver';
import { ForgottenPasswordComponent } from '../forgottenPassword/forgotten-password.component';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';

const routes: Routes = [
  {
      path: '',
      redirectTo: '/home',
      pathMatch: 'full'
  },
  {
      path: 'home',
      component: HomeComponent,
      canActivate: [AuthGuard]
  },
  {
      path: 'analysis',
      component: AnalysisComponent,
      canActivate: [AuthGuard, IsNotDairyGuard],
      resolve: {
        results: AnalysisResolver
      }
  },
  {
      path: 'order/:step/:order_number',
      component: OrderComponent,
      canActivate: [AuthGuard, IsNotDairyGuard],
      resolve: {
        data: OrderResolver,
        order: EditOrderResolver,
        sirets: SiretLabsResolver,
        status: RequestStatusResolver
      },
  },
  {
      path: 'order/:step',
      component: OrderComponent,
      canActivate: [AuthGuard, IsNotDairyGuard],
      resolve: {
        data: OrderResolver
      },
  },
  { path: 'order', redirectTo: '/order/1', pathMatch: 'full' },
  {
      path: 'fast-order/:step/:order_number',
      component: FastOrderComponent,
      canActivate: [AuthGuard, IsNotDairyGuard],
      resolve: {
        data: FastOrderResolver,
        order: EditOrderResolver,
        sirets: SiretLabsResolver,
        status: RequestStatusResolver
      },
  },
  {
      path: 'fast-order/:step',
      component: FastOrderComponent,
      canActivate: [AuthGuard, IsNotDairyGuard],
      resolve: {
        data: FastOrderResolver
      },
  },
  { path: 'fast-order', redirectTo: '/fast-order/1', pathMatch: 'full' },
  {
      path: 'cancellation-list',
      component: CancellationListComponent,
      canActivate: [AuthGuard, IsDairyGuard],
      resolve: {
        orders: CancellationListResolver
      },
  },
  {
      path: 'cancellation/:step',
      component: CancellationComponent,
      canActivate: [AuthGuard, IsDairyGuard],
      resolve: {
        data: CancellationResolver
      },
  },
  { path: 'cancellation', redirectTo: '/cancellation/1', pathMatch: 'full' },
  {
      path: 'login',
      component: LoginComponent
  },
  {
    path: 'forgotten',
    component: ForgottenPasswordComponent
  },
  {
    path: 'reset-pwd',
    component: ResetPasswordComponent
  },
  {
      path: 'bypass',
      component: BypassAuthComponent
  },
  {
      path: 'subscription',
      component: SubscriptionComponent,
      canActivate: [AuthGuard],
      resolve: {
        subscriptionModels: SubscriptionResolver
      }
  },
  {
      path: 'customer-infos',
      component: CustomerInfosComponent,
      canActivate: [AuthGuard],
      resolve: {
        orders: CustomerInfosResolver
      }
  },
  {
      path: 'customer-infos-order/:step',
      component: CustomerInfosOrderComponent,
      canActivate: [AuthGuard, IsDairyGuard],
      resolve: {
        data: CustomerInfosOrderResolver
      }
  },
  { path: 'customer-infos-order', redirectTo: '/customer-infos-order/1', pathMatch: 'full' },
  {
      path: 'my-account',
      component: AccountComponent
  },
  {
      path: 'signup',
      component: SignupComponent
  },
    {
        path: 'additional-docs',
        component: AdditionalDocsComponent,
        resolve: {
            docNames: AdditionalDocResolver
        }
    }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/shared/app-routing.module.ts